<template>
    <div :class="['btn margin-t', classes.button]">
        <span>{{ value }}</span>
    </div>
</template>

<script>
import { BUTTON_TYPES } from "@/assets/JS/Assets.js";

export default {
    name: "Button",
    props: {
        type: String,
        value: String,
        position: String,
        emission: String
    },
    data: () => ({ classes: { button: "" } }),
    beforeMount: function() {
        let typeClass = "";
        switch(this.type) {
            case BUTTON_TYPES.prominent:
                typeClass = "button-white";
                break;
            case BUTTON_TYPES.off:
                typeClass = "button-gray";
                break;
        }
        this.classes.button = `${typeClass} ${this.position.toLowerCase()}`;
    }
};
</script>